<section class="custom-block">
  <div class="fx-col fx-gap-3 px-6 pt-3">
    <div class="fx-row fx-align-center fx-justify-around">
      <customer-title-content [title]="labels.createTitle">
      </customer-title-content>
      <ng-container *ngTemplateOutlet="stepperButton; context: {
          label: labels.homeButton,
          class: 'primary',
          action: goToHome,
        }">
      </ng-container>
    </div>
    <customer-title-content [content]="labels.chooseLoggerTitle">
    </customer-title-content>
  </div>
  <mat-stepper
    #stepper
    class="block-bg-contrast mt-6"
    color="accent"
    [linear]="true"
    [orientation]="stepperOrientation">
    <mat-step
      [stepControl]="monitoringForm"
      [editable]="!isPlantCreated">
      <ng-template matStepLabel>{{ labels.loggerStepLabel }}</ng-template>
      <ng-container *ngTemplateOutlet="monitoring"></ng-container>
      <div class="fx-row fx-center">
        <ng-container *ngTemplateOutlet="stepperButton; context: {
            label: labels.backButton,
            class: 'secondary',
            action: onResetAction,
          }">
        </ng-container>
        <ng-container *ngTemplateOutlet="stepperButton; context: {
            disabled: isMonitoringFormInvalidOrPending,
            action: nextStep,
          }">
        </ng-container>
      </div>
    </mat-step>
    <mat-step
      [stepControl]="plantConfiguration"
      [editable]="!isPlantCreated">
      <ng-template matStepLabel>{{ labels.configurationStepLabel }}</ng-template>
      <ng-container *ngTemplateOutlet="configuration"></ng-container>
      <div class="fx-row fx-center">
        <ng-container *ngTemplateOutlet="stepperButton; context: {
            label: labels.backButton,
            class: 'secondary',
            action: previousStep,
          }">
        </ng-container>
        <ng-container *ngTemplateOutlet="stepperButton; context: {
            disabled: isPlantConfigurationInvalidOrPending,
            action: nextStep,
          }">
        </ng-container>
      </div>
    </mat-step>
    <mat-step [editable]="!isPlantCreated">
      <ng-template matStepLabel>{{ labels.devicesStepLabel }}</ng-template>
      <ng-container *ngIf="isConnextLoggerSelected; else virtualDevicesContainer">
        <ng-container *ngTemplateOutlet="connextDevices"></ng-container>
      </ng-container>
      <ng-template #virtualDevicesContainer>
        <ng-container *ngTemplateOutlet="virtualDevices"></ng-container>
      </ng-template>
      <section class="fx-row fx-center">
        <ng-container *ngIf="!isConnextLoggerSelected">
          <ng-container *ngTemplateOutlet="stepperButton; context: {
              label: labels.backButton,
              class: 'secondary',
              action: previousStep,
            }">
          </ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="stepperButton; context: {
            disabled: isDevicesConfigInvalid,
            label: isConnextLoggerSelected ? labels.nextButton : labels.createButton,
            action: isConnextLoggerSelected ? nextStep : createFirebasePlant,
          }">
        </ng-container>
      </section>
    </mat-step>
    <mat-step
      *ngIf="isConnextLoggerSelected"
      [editable]="!isPlantCreated">
      <ng-template matStepLabel>{{ labels.usersStepLabel }}</ng-template>
      <ng-container *ngTemplateOutlet="connextUsersSection"></ng-container>
      <ng-container *ngTemplateOutlet="stepperButton; context: {
          label: labels.finishButton,
          action: goToConnextPlant,
        }">
      </ng-container>
    </mat-step>
  </mat-stepper>
  <ng-template #monitoring>
    <customer-monitoring-section
      [labels]="{
        alreadyInserted: labels.alreadyInserted,
        alreadyInsertedDescription: labels.alreadyInsertedDescription,
        checkAgain: labels.checkAgain,
        chooseLogger: labels.chooseLogger,
        connext: labels.connext,
        connextPlaceholder: labels.connextPlaceholder,
        connextSerial: labels.connextSerial,
        firmwareNotValidDescription: labels.firmwareNotValidDescription,
        azzurroHubBusy: labels.azzurroHubBusy,
        azzurroHubBusyDescription: labels.azzurroHubBusyDescription,
        firmwareOperationDescription: labels.firmwareOperationDescription,
        fwUpdateContent: labels.fwUpdateContent,
        fwUpdateTitle: labels.fwUpdateTitle,
        import: labels.import,
        offlineDevice: labels.offlineDevice,
        offlineDeviceDescription: labels.offlineDeviceDescription,
        others: labels.others,
        plantAlreadyCreated: labels.plantAlreadyCreated,
        plantAlreadyCreatedDescription: labels.plantAlreadyCreatedDescription,
        requiredOperation: labels.requiredOperation,
        searchSystem: labels.searchSystem,
        systemName: labels.systemName,
        systemNamePlaceholder: labels.systemNamePlaceholder,
        upgradeFirmware: labels.upgradeFirmware,

        deviceNotExists: labels.deviceNotExists,
        deviceNotOnline: labels.deviceNotOnline,
        fwUpgradeInProgress: labels.fwUpgradeInProgress,
        fwVersionNotValidUpgradeRequired: labels.fwVersionNotValidUpgradeRequired,
        hasOwnerAndItsNotYou: labels.hasOwnerAndItsNotYou,
        iAmAlreadyAdmin: labels.iAmAlreadyAdmin,
        serialNotValid: labels.serialNotValid,
        validationError: labels.validationError,
        deviceAlreadyExistsInYourSystemList: labels.deviceAlreadyExistsInYourSystemList,
        deviceAlreadyOnACertifiedPlant: labels.deviceAlreadyOnACertifiedPlant,
      }"
      [loggers]="loggers"
      [monitoringForm]="monitoringForm"
      (wizardFinished)="wizardFinished.emit($event)"
      (changeLogger)="reset()">
    </customer-monitoring-section>
  </ng-template>
  <ng-template #configuration>
    <customer-configuration-section
      [labels]="{
        contractPowerDescription: labels.contractPowerDescription,
        contractPowerPlaceholder: labels.contractPowerPlaceholder,
        contractPowerTitle: labels.contractPowerTitle,
        externalPower: labels.externalPower,
        externalPowerConsider: labels.externalPowerConsider,
        externalPowerDescription: labels.externalPowerDescription,
        externalPowerNotConsider: labels.externalPowerNotConsider,
        externalPowerSelectionPlaceholder: labels.externalPowerSelectionPlaceholder,
        locationDescription: labels.locationDescription,
        locationTitle: labels.locationTitle,
        mapCoordinationPlaceholder: labels.mapCoordinationPlaceholder,
        meterSignDescription: labels.meterSignDescription,
        meterSignInverted: labels.meterSignInverted,
        meterSignNormal: labels.meterSignNormal,
        meterSignPlaceholder: labels.meterSignPlaceholder,
        meterSignTitle: labels.meterSignTitle,
        phaseSelectPlaceholder: labels.phaseSelectPlaceholder,
        plantCreationConnextApply: labels.plantCreationConnextApply,
        plantCreationConnextDisclaimer: labels.plantCreationConnextDisclaimer,
        plantCreationTitle: labels.plantCreationTitle,
        plantName: labels.plantName,
        plantNamePlaceholder: labels.plantNamePlaceholder,
        plantTypeDescription: labels.plantTypeDescription,
        plantTypeDisabled: labels.plantTypeDisabled,
        plantTypeTitle: labels.plantTypeTitle,
        sensorSignDescription: labels.sensorSignDescription,
        sensorSignTitle: labels.sensorSignTitle,
        singlePhase: labels.singlePhase,
        threePhase: labels.threePhase,
        monitoringModeTitle: labels.monitoringModeTitle,
        monitoringModeDescription: labels.monitoringModeDescription,
        monitoringModePlaceholder: labels.monitoringModePlaceholder,
      }"
      [isConnextLoggerSelected]="isConnextLoggerSelected"
      [connextConfiguration]="connextConfiguration"
      [connextSerial]="connextSerial.value"
      [virtualConfiguration]="virtualConfiguration"
      [isConnextOffline]="false"
      [isConnextLoggerOwner]="true"
      [isVerifiedMode]="false"
      (applyConnextChanges)="isPlantCreated = true">
    </customer-configuration-section>
  </ng-template>

  <ng-template #connextDevices>
    <customer-connext-devices-section
      [labels]="{
        applyRegistration: labels.applyRegistration,
        error: labels.error,
        inverterListDescription: labels.inverterListDescription,
        inverterListPlaceholder: labels.inverterListPlaceholder,
        inverterModbusDescription: labels.inverterModbusDescription,
        inverterModbusDescriptionInnerCard: labels.inverterModbusDescriptionInnerCard,
        inverterModbusPlaceholder: labels.inverterModbusPlaceholder,
        inverterRegistrationError: labels.inverterRegistrationError,
        inverters: labels.inverters,
        multiplicativeConstant: labels.multiplicativeConstant,
        productionSensor: labels.productionSensor,
        productionSensorDesc: labels.productionSensorDesc,
        productionSensorDescWithConstMultiplicative: labels.productionSensorDescWithConstMultiplicative,
        productionSensorPlaceholder: labels.productionSensorPlaceholder,
        registered: labels.registered,
        restore: labels.restore,
        restoreDevicesAndSensors: labels.restoreDevicesAndSensors,
        restoreDevicesAndSensorsDescription: labels.restoreDevicesAndSensorsDescription,
        sensorRegistrationError: labels.sensorRegistrationError,
        sensors: labels.sensors,
        setup: labels.setup,
      }"
      [connextDevicesConfig]="connextDevicesConfig"
      [connextSerial]="connextSerial.value"
      [isVerifiedMode]="false"
      [is3PhasePlant]="is3PhasePlant">
    </customer-connext-devices-section>
  </ng-template>
  <ng-template #virtualDevices>
    <customer-virtual-devices-section
    [labels]="{
      addInverter: labels.addInverter,
      inverterListDescription: labels.inverterVirtualListDescription,
      inverterListPlaceholder: labels.inverterListPlaceholder,
      inverterListTitle: labels.inverterListTitle,
    }"
    [virtualDevicesConfig]="virtualDevicesConfig"
    [inverterValidators]="{
      syncValidators: inverterSyncValidators,
      asyncValidators: inverterAsyncValidators,
    }">
    </customer-virtual-devices-section>
  </ng-template>
  <ng-template #connextUsersSection>
    <customer-users-section
      [labels]="{
        add: labels.add,
        admin: labels.admin,
        authorizations: labels.authorizations,
        delete: labels.delete,
        email: labels.email,
        owner: labels.owner,
        userManagement: labels.userManagement,
        userManagementDescription: labels.userManagementDescription,
        userManagementPlaceholder: labels.userManagementPlaceholder,
        updateUsersAuthorizations: labels.updateUsersAuthorizations,
      }"
      [connextSerial]="connextSerial.value"
      [connextUsers]="connextUsers"
      [showUnsavedChanges]="false">
    </customer-users-section>
  </ng-template>

  <ng-template
    #stepperButton
    let-disabled="disabled"
    let-label="label"
    let-action="action"
    let-class="class">
    <button
      class="mt-3 custom-mat-button-{{ class || 'primary' }}"
      mat-button
      [disabled]="disabled"
      (click)="action && action()">
      {{ label || labels.nextButton }}
    </button>
  </ng-template>
</section>
